// extracted by mini-css-extract-plugin
module.exports = {"floating":"styles_floating__ca2Pv","floatingHidden":"styles_floatingHidden__mryi_"};